import { useState, type ReactNode } from 'react';
import { ChevronRight } from 'lucide-react';
import { Button } from '@resource-kit/ui/react';
import { cn } from '@resource-kit/ui';

/** A secondary block that stays collapsed until asked for. */
export function Disclosure({
  title,
  children,
  contentTestId,
}: {
  title: string;
  children: ReactNode;
  contentTestId?: string;
}) {
  const [open, setOpen] = useState(false);

  return (
    <div className="flex flex-col gap-3">
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="-ml-3 self-start text-muted-foreground hover:text-foreground"
        aria-expanded={open}
        onClick={() => setOpen((current) => !current)}
      >
        <ChevronRight
          data-icon="inline-start"
          className={cn('transition-transform', open && 'rotate-90')}
        />
        {title}
      </Button>
      {open && <div data-testid={contentTestId}>{children}</div>}
    </div>
  );
}
